const initialState = {
    data: [], 
    datass:[],
    datasss:[],
    remove:[],
    
  
  };
  
  const SupLinkAssistantsReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_DATA_SUCCESS':
            return {... state, data:action.payload};
            case 'FETCH_DATA1_SUCCESS':
            return {... state, datass:action.payload};
            case 'FETCH_DATA2_SUCCESS':
            return {... state, datasss:action.payload};
            case 'FETCH_REMOVE_SUCCESS':
            return {... state, remove:action.payload};
           
            
           
          


      default:
        return state;
    }
  };
  
  export default SupLinkAssistantsReducers;
  
  